<div class="button-container">
  @if (hasIntegration('qbo')) {
    <button (click)="startIntegrationImport('qbo')"
      class="btn btn-light" type="button">
      <span>Import from QBO</span>
    </button>
  }
  @if (hasIntegration('xero')) {
    <button (click)="startIntegrationImport('xero')"
      class="btn btn-light" type="button">
      <span>Import from Xero</span>
    </button>
  }
  @if (hasManageDocumentPermission) {
    <button (click)="openUploadDocumentModal()"
      class="btn btn-light-primary mb-1" type="button">
      <i class="fa-solid fa-arrow-up-from-bracket"></i>
      <span>Upload Documents</span>
    </button>
  }
</div>


